import React from 'react';
import DataTable from '../reporting_utils/DataTable';

const $ = window.$;

/**
 * @param {{
 *   tableData: Array;
 *   isAutomotiveIndustry: boolean;
 *   industryType: string;
 * }} props
 */
export default function TrafficAnalysisTable({ tableData, isAutomotiveIndustry, industryType }) {
  const columnDefs = React.useMemo(() => {
    /** @type {string[]} */
    let callTypes = [];
    switch (industryType) {
      case 'Automotive':
        callTypes = ['Sales', 'Service', 'Parts'];
        break;
      case 'Pest':
        callTypes = ['One-Time Service', 'Recurring Service'];
        break;
      case 'Home Improvement':
        // callTypes = ['Sales', 'Service', 'Other', 'Current Customer']; -- Removed for transition
        callTypes = ['Sales', 'Service'];
        break;
      case 'Healthcare':
        callTypes = ['Prospect'];
        break;
      case 'Other':
        callTypes = ['Sales', 'Prospect', 'Current Customer', 'General Business'];
        break;
      default:
        callTypes = [];
    }

    /** @type {import('../reporting_utils/DataTable').Column[]} */
    const columns = [];

    columns.push({ data: 'adsource', title: 'Source' });

    if (industryType !== 'Call Center') {
      columns.push({ data: 'ref_medium', title: 'Referral' });
      columns.push({
        data: 'chats',
        render: $.fn.dataTable.render.number(','),
        title: 'Chats',
        aggregation: 'sum',
      });
      columns.push({
        data: 'leads',
        render: $.fn.dataTable.render.number(','),
        title: 'WebForms',
        aggregation: 'sum',
      });
      columns.push({
        data: 'texts',
        render: $.fn.dataTable.render.number(','),
        title: 'Texts',
        aggregation: 'sum',
      });
    }

    columns.push({
      data: 'calls',
      render: $.fn.dataTable.render.number(','),
      title: 'Calls',
      aggregation: 'sum',
    });

    callTypes.forEach((callType) => {
      columns.push({
        data: callType.replace(/[^a-z]/gi, '_').toLowerCase(),
        render: $.fn.dataTable.render.number(','),
        title: callType,
        aggregation: 'sum',
      });
    });

    columns.push({
      data: 'appts',
      render: $.fn.dataTable.render.number(','),
      title: isAutomotiveIndustry ? 'Appointments Made' : 'Booked',
      aggregation: 'sum',
    });

    if (industryType !== 'Call Center') {
      columns.push({
        data: 'noappts',
        render: $.fn.dataTable.render.number(','),
        title: isAutomotiveIndustry ? 'Alerts' : 'Missed Opps',
        aggregation: 'sum',
      });
      columns.push({
        data: 'appt_conversion',
        className: 'table_percent_bar',
        render(data) {
          if (data) {
            return `
            <div class='bar_label'>${data}%</div>
            <div style='position:relative;' class='bar'>
              <div style='width:${data}%;' class='bar_filler'></div>
            </div>`;
          } else {
            return null;
          }
        },
        title: 'Appointment Conversion',
      });
    } else {
      columns.push({
        data: 'missedops',
        render: $.fn.dataTable.render.number(','),
        title: isAutomotiveIndustry ? 'Alerts' : 'Missed Opps',
        aggregation: 'sum',
      });
    }

    return columns;
  }, [industryType, isAutomotiveIndustry]);

  const order = React.useMemo(() => {
    const callsColumnIndex = columnDefs.findIndex((column) => column.data === 'calls');
    return [[callsColumnIndex, 'desc']];
  }, [columnDefs]);

  return (
    <div className='row row_spacer'>
      <div className='col-xs-12'>
        <div className='report_data_container'>
          <div className='title'>Conversion</div>
          <DataTable
            columnDefs={columnDefs}
            data={tableData}
            showTotalFooter={true}
            order={order}
            title='Conversion'
          />
        </div>
      </div>
    </div>
  );
}
